import { getProductId } from './../../../order-builder/modules/specification/helpers/product.helper';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { OneClickBuilderField } from '../../util/constants/builder-fields';
import { productWithPreloaded } from '../../selectors/one-click-products.selector';

@Injectable()
export class OneClickProductsLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(productWithPreloaded),
      map(({ products, preloadedOrder }) => {
        if (preloadedOrder) {
          const product = products.find(
            (productAvailable) => getProductId(productAvailable) === preloadedOrder.items[0].product.productId,
          );
          product && formGroup.controls[OneClickBuilderField.Product].setValue(getProductId(product));
        }
        return products.map((product) => {
          return {
            id: getProductId(product),
            name: `${product.commercialCode.replace(/^0+/, '')} / ${product.commercialDesc}`,
          };
        });
      }),
    );
  }
}
